import { ref } from 'vue';

export const useVisibleOffers = (startAmount: number) => {
  const offers = ref(startAmount);

  const increaseVisibleOffers = (amount: number) => {
    offers.value += amount;
  };

  return {
    offers,
    increaseVisibleOffers,
  };
};
